<template>
  <div class="author flex-wrap h-full">
    <img
      class="author-img"
      :src="require('@/assets/images/man-avatar.png')"
      alt="author-img"
    />
    <div class="pl-2">      
      <strong class="flex w-full">Created by:</strong>
      <span class="auhthor-name"
      > {{ this.author ? this.author : "John Doe" }}</span
    >
    </div>
    
  </div>
</template>
<script>
export default {
  name: "AuthorNameCell",
  props: {
    author: String,
  },
  mounted() {
    this.authorName = this.author;
  },
  data() {
    return {
      authorName: "",
    };
  },
};
</script>
<style>
.author {
  display: flex;
  align-items: center;
}
.author-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  align-items: center;
}

.author-name {
  margin-left: 15px !important;
  color: #5e5873 !important;
}
</style>
